module.exports = __webpack_public_path__ + "f66931e863eedd6094402640db25a8ad.svg";